import React from 'react';

const Profile = (props) =>{
    const myProfile = (
        <div>
            {props.profile.map((pro)=>
            <div className='item' key={pro.personal}>
                <h3>{pro.personal}</h3>
                <p>{pro.profileDescription}</p>
                <cite>{pro.profileDescription2}</cite>
            </div>
            )}
        </div>
    );
    return(
        <div className='title'>
            <i className='fa fa-product-hunt'></i>
            <h2>PROFILE</h2>
            {myProfile}
        </div>
    )
};
export default Profile;